define('app/routers/travel_search_router',['app/setup'], function(takhfifan) {
  var TravelSearchRoute = Backbone.Router.extend({
    routes: {
      "travel_search/type/:category": "searchCategory",
      "travel_search/location/:location": "searchLocation",
      "travel_search/:category/:location": "search",
      "travel_type/:type": "changeType",
      "travel_view/:view/:id": "changeView",
      "travel_view/:view": "changeView",
      ":city(/)/hotel/:id/:name": "hotelView"
    },

    execute: function(callback, args, name) {
      if (!takhfifan.travelSectionInited) {
        takhfifan.travelInitRoute = {callback:callback, args:args};
        return false;
      }
      if (callback) callback.apply(this, args);
    },

    searchCategory: function (category) {
      takhfifan.eventHub.trigger('travel:viewChanged', {view:"search"});
      takhfifan.eventHub.trigger('travel:typeChanged', {type:"default"});
      takhfifan.eventHub.trigger('travel:search', {category: category});
    },

    searchLocation: function(location) {
      takhfifan.eventHub.trigger('travel:viewChanged', {view:"search"});
      takhfifan.eventHub.trigger('travel:typeChanged', {type:"default"});
      takhfifan.eventHub.trigger('travel:search', {location: decodeURIComponent(location)});
    },

    search: function(category, location) {
      takhfifan.eventHub.trigger('travel:viewChanged', {view:"search"});
      takhfifan.eventHub.trigger('travel:typeChanged', {type:"default"});
      takhfifan.eventHub.trigger('travel:search', {category:category, location: decodeURIComponent(location)});
    },

    changeType: function(type){
      takhfifan.eventHub.trigger('travel:viewChanged', {view:"search"});
      takhfifan.eventHub.trigger('travel:typeChanged', {type:type});
    },

    changeView: function (view, id) {
      window.scrollTo(0,0);
      takhfifan.eventHub.trigger('travel:viewChanged', {view: view, id:id});
    },

    hotelView: function (city, id, name) {
      window.scrollTo(0,0);
      takhfifan.eventHub.trigger('travel:viewChanged', {view: 'hotelDetail', city:city, id:id, name:name});
    }

  });

  if($('.tkh-travel-search').length){
    takhfifan.travelSearchRoute =  new TravelSearchRoute;
  }
});
